var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-player"},[_c('div',{staticClass:"title"},[_vm._v("对局详情")]),_c('div',{staticClass:"list"},_vm._l((_vm.teamList),function(team,index){return _c('PlayerList',{key:index,attrs:{"teamInfo":team,"type":index == 0 ? 'green' : 'red'}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }